export const BlobFetcher = {
  fetchBlobEncoded(url: string): Promise<string> {
    return Promise.resolve('');
  }
};
